<template>
  <cn-edit
    @editSubmited="updateForm"
    @expDateSet="setExirationDate"
    @backEmit="cancel"
    :title="'Edit ' + form.formTitle"
  >
    <div class="row flex">
      <va-input
        :class="isExpiredClass"
        :disabled="true"
        label="Form Title"
        v-model="form.formTitle"
      ></va-input>

      <va-input
        :class="isExpiredClass"
        :disabled="true"
        label="Form Title"
        v-model="form.createdDate"
      ></va-input>

      <transition name="fade" mode="out-in">
        <va-date-picker
          v-if="showExpirationDate"
          :disabled="true"
          :class="isExpiredClass"
          label="Expiration Date"
          :config="{dateFormat:'d/m/Y'}"
          v-model="form.expirationDate"
        />
      </transition>
    </div>

    <div class="flex">
      <va-input type="textarea" :disabled="true" label="Form Question" v-model="form.formQuestion"></va-input>

      <va-data-table style="cursor:pointer" @row-clicked="debug" :fields="fields" :data="form.formConsents"></va-data-table>
    </div>

    <template v-slot:editSlot>
      <cn-fields
        :canEdit="canEdit"
        :fields="fields"
        :editFormConsents="editFormConsents "
        :form="editedForm"
      ></cn-fields>
    </template>

    <template v-slot:extraButtons>
      <va-button @click.prevent="editFormConsents=!editFormConsents" color="info">{{buttonName}}</va-button>
    </template>

  </cn-edit>

</template>

<script>
import vaEdit from '../../consentTemplates/Edit.vue'
import editFields from './EditFields.vue'
import formsService from '../ConsentFormsService.js'
import _ from 'lodash'

export default {
  data () {
    return {
      form: {
        formQuestion: '',
        formTitle: '',
        formConsents: [],
        createdDate: '',
        expirationDate: '',
      },
      editedForm: {
        formQuestion: '',
        formTitle: '',
        formConsentDTOS: [],
        comments: '',
      },
      editFormConsents: true,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'consentTitle',
          title: 'Consent Title',
        },
      ]
    },
    showExpirationDate () {
      if (this.form.expirationDate != undefined) {
        return true
      }
      return false
    },
    buttonName () {
      return this.editFormConsents === true
        ? "Edit Form's Fields"
        : "Edit Form's Consents"
    },
    isExpiredClass () {
      return {
        flex: true,
        xs12: true,
        md4: this.form.expirationDate != undefined,
        md6: this.form.expirationDate == undefined,
      }
    },
    canEdit () {
      return this.$store.getters.clearance
    },
  },
  methods: {
    debug () {
      console.log('hey')
    },
    cancel () {
      this.$router.push({ name: 'consentForms' })
    },
    updateForm () {
      this.editedForm._id = this.form._id

      this.editedForm.formConsentDTOS.forEach(consent => {
        consent.consentId = consent._id
        consent._id = null
      })

      formsService.updateForm(this.editedForm).then(res => {
        this.$toasted.success('Form Edited Succesfully', {
          icon: 'fa-check',
          position: 'top-right',
          duration: 2000,
          fullWidth: false,

        })

        this.$store.dispatch('setForm', res.data)
      }).catch(error => {
        const message =
        error.response.data.message == undefined
          ? 'Something went wrong'
          : error.response.data.message

        this.$toasted.error(message, {
          icon: 'fa-close',
          position: 'top-right',
          duration: 2000,
          fullWidth: false,
        })
      })
    },
    setExirationDate (expirationDate) {
      if (this.form.createdDate < expirationDate) {
        this.form.expirationDate = expirationDate
      }
    },
  },
  components: {
    'cn-edit': vaEdit,
    'cn-fields': editFields,

  },
  created () {
    let storeForm = this.$store.getters.form
    this.editedForm.formConsentDTOS = []
    Object.assign(this.form, this.$store.getters.form)
    if (this.canEdit) {
      Object.assign(this.editedForm, this.form)

      this.editedForm.formConsentDTOS = _.cloneDeep(storeForm.formConsents)

      delete this.editedForm.formConsents
      delete this.editedForm.createdDate
      delete this.editedForm.expirationDate
    }
  },
}
</script>

<style scoped>
va-input {
  display: flex;
}

.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-leave {
}
.fade-leave-active {
  transition: opacity 1s;
  opacity: 0;
}
</style>
